<script>
    import {query} from "svelte-pathfinder";

    const errors = {
        default: "Unable to sign in.",
        signin: "Try signing in with a different account.",
        oauthsignin: "Try signing in with a different account.",
        oauthcallback: "Try signing in with a different account.",
        oauthcreateaccount: "Try signing in with a different account.",
        emailcreateaccount: "Try signing in with a different account.",
        callback: "Try signing in with a different account.",
        oauthaccountnotlinked:
            "To confirm your identity, sign in with the same account you used originally.",
        emailsignin: "The e-mail could not be sent.",
        credentialssignin:
            "Sign in failed. Check the details you provided are correct.",
        sessionrequired: "Please sign in to access this page.",
    }

    console.log($query.error, $query.error ? errors[$query.error] : '');

    // NB.. when you pass a custom 'signin' route to the 'pages' param in getWorkerAuthConfig AuthJS will 302 redirect
    // /api/auth/signin _external_ link to the route you passed and will append a `callbackUrl` query param - this
    // doesn't work when we do an internal (svelte-pathfinder) redirect. It looks like the callbackUrl is always just
    // the origin/root of the site, e.g. https://localhost:8787/ - so here am just grabbing that and using it instead..
    // NB.. the provider.callbackUrl _is not_ the one you want (weirdly) - it throws an error _shrugs_
    let callback_url = window.location.origin;

    export let auth_state;

</script>


<div class="absolute top-16 right-0 bottom-0 left-0 overflow-y-auto">
    {#if auth_state.fetching}
        Fetching..
    {:else if auth_state.failed_to_load_data}
        Failed to load data..
    {:else}
        <!-- TODO display errors -->
        <!-- TODO handle other forms of provider, e.g. email -->
        {#each Object.values(auth_state.providers) as provider}
            <form action="{provider.signinUrl}" method="POST">
                <input type="hidden" name="csrfToken" value="{auth_state.csrf}">
                <input type="hidden" name="callbackUrl" value="{callback_url}">
                <button type="submit" class="button" style="--provider-bg: #fff; --provider-dark-bg: #24292f; --provider-color: #000; --provider-dark-color: #fff; gap: 8px;">
                    <!-- TODO vary these based on provider type -->
                    <img loading="lazy" height="24" width="24" id="provider-logo" src="https://authjs.dev/img/providers/github.svg">
                    <img loading="lazy" height="24" width="24" id="provider-logo-dark" src="https://authjs.dev/img/providers/github-dark.svg">
                    <span>Sign in with GitHub</span>
                </button>
            </form>
            {/each}
    {/if}

</div>


<style></style>